module.exports = "<p>\n  design works!\n</p>\n"